import api from "../api";

// The official server renderer is the only source of PDFs. The authenticated
// request carries document identity, never browser HTML or a raster screenshot.
export async function createDocumentPdfFile(kind, id, copyLabel, filename, signal) {
  const { data } = await api.get(`/documents/${encodeURIComponent(kind)}/${encodeURIComponent(id)}/pdf`, {
    params: { copy_label: copyLabel }, responseType: "blob", signal, timeout: 30000,
  });
  if (!data || data.type !== "application/pdf") throw new Error("The server did not return a PDF");
  return new File([data], filename, { type: "application/pdf" });
}

// Use the authorized PDF bytes, not a protected app route whose sessionStorage
// is absent in a noopener tab. Give this tab its own URL: closing the preview
// must not revoke it. The browser releases it when the source document unloads.
export function openDocumentPdfTab(file) {
  if (!file || file.type !== "application/pdf") return;
  const url = URL.createObjectURL(file);
  window.open(url, "_blank", "noopener,noreferrer");
}
